import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaPinterestP, FaLinkedin, FaInstagram, FaVimeoV, FaDribbble, FaBehance, FaEnvelopeOpen, FaTiktok } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { useTranslation } from 'react-i18next';

import ServiceData from '../../data/service/ServiceMain.json';
import { slugify } from '../../utils';

const getServiceData = ServiceData;

const FooterOne = ({ parentClass, variant = 'default' }) => {
  const { t } = useTranslation();

  if (variant === 'mutawir') {
    const legalLinks = t('footer.legal', { returnObjects: true }) || [];
    const wrapperClass = ['mutawir-footer', parentClass].filter(Boolean).join(' ');

    return (
      <footer className={wrapperClass}>
        <div className="container">
          <div className="mutawir-footer__inner">
            <p className="mutawir-footer__tagline">{t('footer.tagline')}</p>
            <div className="mutawir-footer__social" aria-label={t('footer.followUs', { defaultValue: 'Follow Mutawir Studios' })}>
              <a
                href="https://www.facebook.com/people/Mutawir/61582563313284/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <FaFacebookF />
                <span>Facebook</span>
              </a>
              <a
                href="https://www.instagram.com/mutawir_studios/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <FaInstagram />
                <span>Instagram</span>
              </a>
              <a
                href="https://www.tiktok.com/@mutawir_studios"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="TikTok"
              >
                <FaTiktok />
                <span>TikTok</span>
              </a>
            </div>
            <div className="mutawir-footer__bottom">
              <span className="mutawir-footer__rights">{t('footer.rights')}</span>
              <div className="mutawir-footer__links">
                {legalLinks.map((link, index) => {
                  if (!link.href) {
                    return null;
                  }

                  if (link.href.startsWith('/')) {
                    return (
                      <Link key={index} to={link.href}>
                        {link.label}
                      </Link>
                    );
                  }

                  return (
                    <a key={index} href={link.href}>
                      {link.label}
                    </a>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }

  return (
    <footer className={`footer-area ${parentClass}`}>
      <div className="container">
        <div className="footer-top">
          <div className="footer-social-link">
            <ul className="list-unstyled">
              <li><Link to="https://facebook.com/"><FaFacebookF /></Link></li>
              <li><Link to="https://twitter.com/"><FaXTwitter /></Link></li>
              <li><Link to="https://www.pinterest.com/"><FaPinterestP /></Link></li>
              <li><Link to="https://www.linkedin.com/"><FaLinkedin /></Link></li>
              <li><Link to="https://www.instagram.com/"><FaInstagram /></Link></li>
              <li><Link to="https://vimeo.com/"><FaVimeoV /></Link></li>
              <li><Link to="https://dribbble.com/"><FaDribbble /></Link></li>
              <li><Link to="https://www.behance.net/"><FaBehance /></Link></li>
              <li><Link to="https://www.tiktok.com/en/"><FaTiktok /></Link></li>
            </ul>
          </div>
        </div>
        <div className="footer-main">
          <div className="row">
            <div className="col-xl-6 col-lg-5">
              <div className="footer-widget border-end">
                <div className="footer-newsletter">
                  <h2 className="title">Get in touch!</h2>
                  <p>Fusce varius, dolor tempor interdum tristique, dui urna bib endum magna, ut ullamcorper purus</p>
                  <form>
                    <div className="input-group">
                      <span className="mail-icon"><FaEnvelopeOpen /></span>
                      <input type="email" className="form-control" placeholder="Email address" />
                      <button className="subscribe-btn" type="submit">Subscribe</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-7">
              <div className="row">
                <div className="col-sm-6">
                  <div className="footer-widget">
                    <h6 className="widget-title">Services</h6>
                    <div className="footer-menu-link">
                      <ul className="list-unstyled">
                        {getServiceData.slice(0, 6).map((data, index) => (
                          <li key={index}>
                            <Link to={`/service-details/${slugify(data.title)}`}>
                              {data.title}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="footer-widget">
                    <h6 className="widget-title">Resourses</h6>
                    <div className="footer-menu-link">
                      <ul className="list-unstyled">
                        <li><Link to="/blog-grid">Blog</Link></li>
                        <li><Link to="/case-study">Case Studies</Link></li>
                        <li><Link to="/project-grid-one">Portfolio</Link></li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="footer-widget">
                    <h6 className="widget-title">Support</h6>
                    <div className="footer-menu-link">
                      <ul className="list-unstyled">
                        <li><Link to="/contact">Contact</Link></li>
                        <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                        <li><Link to="/terms-use">Terms of Use</Link></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="row">
            <div className="col-md-6">
              <div className="footer-copyright">
                <span className="copyright-text">
                  © {new Date().getFullYear()}. All rights reserved by <a href="https://axilthemes.com/">Axilthemes</a>.
                </span>
              </div>
            </div>
            <div className="col-md-6">
              <div className="footer-bottom-link">
                <ul className="list-unstyled">
                  <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                  <li><Link to="/terms-use">Terms of Use</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

FooterOne.defaultProps = {
  parentClass: '',
  variant: 'default'
};

export default FooterOne;
